import { render } from "./MsChatGPTModal.vue?vue&type=template&id=41f22371&scoped=true&ts=true"
import script from "./MsChatGPTModal.vue?vue&type=script&lang=ts"
export * from "./MsChatGPTModal.vue?vue&type=script&lang=ts"

import "./MsChatGPTModal.vue?vue&type=style&index=0&id=41f22371&lang=scss&scoped=true"

import exportComponent from "/Users/kameyamanaoki/dev/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41f22371"]])

export default __exports__